import React from 'react'
import UseIncomeLangFeeType from '../../../hooks/use-income-lang-fee'
import UseIncomeOTFlatrateType from '../../../hooks/use-income-ot-flatrate'
import UseIncomeEXPFeeType from '../../../hooks/use-income-exp-fee'
import UseIncomeShiftFlatrateType from '../../../hooks/use-income-shift-flatrate'
import { Controller } from 'react-hook-form'
import Autocomplete from '../../custom/autocomplete'
import LabelCustom from '../../label-custom'
import { Card, Col, Row } from 'react-bootstrap'
import UsePhone from '../../../hooks/use-phone'
import UseEmpsTravels from '../../../hooks/use-emps-travels'

export default function IncomeFrom({ control, errors }) {
  const langFeeType = UseIncomeLangFeeType()
  const OTFlatrateType = UseIncomeOTFlatrateType()

  const expFeeType = UseIncomeEXPFeeType()
  const shiftFlatrate = UseIncomeShiftFlatrateType()
  const phone = UsePhone()
  const travels = UseEmpsTravels()

  return (
    <Card border="0">
      <Card.Body>
        <h5 className="mb-3 fw-bold ">ข้อมูลรายได้</h5>
        <Row className="" style={{ rowGap: '15px' }}>
          <Col xl={3} md={6}>
            <LabelCustom text="การเดินทาง" />
            <Controller
              name={'travel'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Autocomplete
                  isClearable
                  options={travels}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
            {errors.travel && (
              <label className="small text-danger">
                {errors.travel.message}
              </label>
            )}
          </Col>
          <Col xl={3} md={6}>
            <LabelCustom text="ค่าโทรศัพท์" />
            <Controller
              name={'phone'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Autocomplete
                  isClearable
                  options={phone}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
            {errors.phone && (
              <label className="small text-danger">
                {errors.phone.message}
              </label>
            )}
          </Col>
          <Col xl={3} className="">
            <LabelCustom text="OT เหมาจ่าย" />
            <Controller
              name={'otFlatRate'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Autocomplete
                  options={OTFlatrateType}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
            {errors.otFlatRate?.message && (
              <label className="small text-danger">
                {errors.otFlatRate.message}
              </label>
            )}
          </Col>
          <Col xl={3}>
            <LabelCustom text="OT วันทำงานปกติ" />
            <Controller
              name={'otShift'}
              control={control}
              render={({ field: { onChange, value = null } }) => (
                <Autocomplete
                  options={[
                    { label: 'ไม่มี', value: 0 },
                    { label: 'มี', value: 1 }
                  ]}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
            {errors.otShift?.message && (
              <label className="small text-danger">
                {errors.otShift.message}
              </label>
            )}
          </Col>
          <Col xl={3}>
            <LabelCustom text="ค่าภาษา" />
            <Controller
              name={'languageFee'}
              control={control}
              render={({ field: { onChange, value = null } }) => (
                <Autocomplete
                  options={langFeeType}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
            {errors.languageFee?.message && (
              <label className="small text-danger">
                {errors.languageFee.message}
              </label>
            )}
          </Col>
          <Col xl={3}>
            <LabelCustom text="ค่าประสบการณ์" />
            <Controller
              name={'experienceFee'}
              control={control}
              render={({ field: { onChange, value = null } }) => (
                <Autocomplete
                  options={expFeeType}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
            {errors.experienceFee?.message && (
              <label className="small text-danger">
                {errors.experienceFee.message}
              </label>
            )}
          </Col>
          <Col xl={3}>
            <LabelCustom text="ค่ากะเหมาจ่าย" />
            <Controller
              name={'shiftFlatRate'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Autocomplete
                  options={shiftFlatrate}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
            {errors.shiftFlatRate?.message && (
              <label className="small text-danger">
                {errors.shiftFlatRate.message}
              </label>
            )}
          </Col>
        </Row>
      </Card.Body>
    </Card>
  )
}
